"use strict";

var _interopRequireWildcard = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js"));
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.iterator.some.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.number.to-fixed.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.set.js");
require("core-js/modules/es.set.difference.v2.js");
require("core-js/modules/es.set.intersection.v2.js");
require("core-js/modules/es.set.is-disjoint-from.v2.js");
require("core-js/modules/es.set.is-subset-of.v2.js");
require("core-js/modules/es.set.is-superset-of.v2.js");
require("core-js/modules/es.set.symmetric-difference.v2.js");
require("core-js/modules/es.set.union.v2.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.string.pad-start.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.search.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/esnext.json.parse.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _lodash = _interopRequireDefault(require("lodash"));
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _organizations = require("@/api/organizations");
var _loop = require("@/api/loop");
var _hike = require("@/api/hike");
var _user = require("@/api/user");
var _utils = require("@/utils");
var Constants = _interopRequireWildcard(require("@lifehikes/lh-js-common-lib"));
var _subscriptions = require("@/api/subscriptions");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SubscriptionEdit',
  data: function data() {
    return {
      activeTab: 'info',
      loggedInUserTenants: [],
      fullscreenloading: false,
      dialogLoopVisible: false,
      loopTableLoading: false,
      dialogCoachVisible: false,
      coachTableLoading: false,
      organizations: [],
      loopList: [],
      loopTotal: 0,
      loopQuery: {
        page: 1,
        limit: 5,
        q: undefined
      },
      coachList: [],
      coachTotal: 0,
      coachQuery: {
        page: 1,
        limit: 5,
        q: undefined
      },
      form: {
        id: '',
        tenant: '',
        organization: '',
        title: '',
        startDate: '',
        endDate: '',
        status: 'Published',
        loops: [],
        coaches: [],
        sessionsPerUser: 0,
        overallQuota: 0,
        expiryDate: '',
        performance: {
          checkinPassingRate: 80,
          minimumStepCount: 0
        }
      },
      savedForm: null,
      initialSessionsPerUser: 0,
      updateCount: 0,
      allSubscriptions: [],
      userRecordsList: [],
      userRecordsStats: null,
      userRecordsTotal: 0,
      userRecordsLoading: false,
      userRecordsQuery: {
        page: 1,
        limit: 10,
        search: ''
      },
      dialogChangelogVisible: false,
      selectedUserChangelog: [],
      selectedUserName: '',
      dialogBookingsVisible: false,
      bookingsLoading: false,
      bookingsList: [],
      coachMap: {},
      dialogMandatoryActivitiesVisible: false,
      selectedUserMandatoryActivities: [],
      quotaType: 'unlimited',
      limitedQuotaValue: 1000
    };
  },
  computed: {
    totalCheckinStageCount: function totalCheckinStageCount() {
      if (!this.userRecordsStats) return 0;
      var hikesInfo = this.userRecordsStats.relatedHikesInfo || this.userRecordsStats.data && this.userRecordsStats.data.relatedHikesInfo;
      if (hikesInfo && hikesInfo.totalCheckinStageCount !== undefined && hikesInfo.totalCheckinStageCount !== null) {
        return Number(hikesInfo.totalCheckinStageCount);
      }
      return 0;
    },
    totalStepCount: function totalStepCount() {
      if (!this.userRecordsStats) return 0;
      var hikesInfo = this.userRecordsStats.relatedHikesInfo || this.userRecordsStats.data && this.userRecordsStats.data.relatedHikesInfo;
      if (hikesInfo && hikesInfo.totalStepCount !== undefined && hikesInfo.totalStepCount !== null) {
        return Number(hikesInfo.totalStepCount);
      }
      return 0;
    },
    totalMandatoryHikeActivityCount: function totalMandatoryHikeActivityCount() {
      if (!this.userRecordsStats) return this.mandatoryHikeActivities ? this.mandatoryHikeActivities.length : 0;
      var hikesInfo = this.userRecordsStats.relatedHikesInfo || this.userRecordsStats.data && this.userRecordsStats.data.relatedHikesInfo;
      if (hikesInfo && hikesInfo.totalMandatoryHikeActivityCount !== undefined && hikesInfo.totalMandatoryHikeActivityCount !== null) {
        return Number(hikesInfo.totalMandatoryHikeActivityCount);
      }
      if (hikesInfo && hikesInfo.mandatoryHikeActivityCount !== undefined && hikesInfo.mandatoryHikeActivityCount !== null) {
        return Number(hikesInfo.mandatoryHikeActivityCount);
      }
      return this.mandatoryHikeActivities ? this.mandatoryHikeActivities.length : 0;
    },
    mandatoryHikeActivities: function mandatoryHikeActivities() {
      if (!this.form || !Array.isArray(this.form.loops)) return [];
      var activities = [];
      var seenKeys = new Set();
      this.form.loops.forEach(function (loop) {
        if (Array.isArray(loop.hikes)) {
          loop.hikes.forEach(function (hike) {
            if (Array.isArray(hike.mandatoryActivities)) {
              hike.mandatoryActivities.forEach(function (item) {
                var uniqueKey = "".concat(item.hikeId, "_").concat(item.actionId || item.displayText);
                if (!seenKeys.has(uniqueKey)) {
                  seenKeys.add(uniqueKey);
                  activities.push(item);
                }
              });
            }
          });
        }
      });
      return activities;
    }
  },
  watch: {
    '$route.hash': {
      handler: function handler(hash) {
        if (hash === '#user-records') {
          this.activeTab = 'user-records';
        }
      },
      immediate: true
    }
  },
  created: function created() {
    this.getOrganizationsList();
    this.getLoggedInUserTenants();
    this.loadSubscription();
    this.loadUserRecords();
    this.loadUserRecordsStatistics();
  },
  methods: {
    getTenantLabel: _utils.getTenantLabel,
    handleQuotaTypeChange: function handleQuotaTypeChange(type) {
      if (type === 'unlimited') {
        this.form.overallQuota = 0;
      } else if (type === 'limited') {
        if (!this.limitedQuotaValue || Number(this.limitedQuotaValue) <= 0) {
          this.limitedQuotaValue = 1000;
        }
        this.form.overallQuota = Number(this.limitedQuotaValue);
      }
    },
    handleLimitedQuotaChange: function handleLimitedQuotaChange(val) {
      var num = Number(val);
      this.limitedQuotaValue = num > 0 ? num : 1000;
      this.form.overallQuota = this.limitedQuotaValue;
    },
    getLoggedInUserTenants: function getLoggedInUserTenants() {
      if (this.$store.getters.userMetadata && this.$store.getters.userMetadata.tenants) {
        this.loggedInUserTenants = this.$store.getters.userMetadata.tenants;
      } else {
        this.loggedInUserTenants = [Constants.TENANT_LIFEHIKES, Constants.TENANT_LIFEHIKES_FOUNDATION];
      }
    },
    getOrganizationsList: function getOrganizationsList() {
      var _this = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _organizations.getAllOrganizations)(token).then(function (response) {
        if (response.data && response.data.rows) {
          _this.organizations = response.data.rows.map(function (org) {
            return {
              id: org.id,
              name: org.name
            };
          });
        }
      }).catch(function (error) {
        (0, _log.showDebugLog)('getAllOrganizations-api-error', error);
      });
    },
    loadSubscription: function loadSubscription() {
      var _this2 = this;
      var subId = this.$route.params.id;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      if (token && subId) {
        this.fullscreenloading = true;
        (0, _subscriptions.getSubscriptionById)(token, subId).then(function (response) {
          var subData = response.data;
          var form = {
            id: subData.id,
            tenant: subData.metadata ? subData.metadata.tenant : '',
            organization: subData.organizationId,
            title: subData.title,
            startDate: subData.startDate ? subData.startDate.substring(0, 10) : '',
            endDate: subData.endDate ? subData.endDate.substring(0, 10) : '',
            status: subData.status ? subData.status.charAt(0).toUpperCase() + subData.status.slice(1) : 'Published',
            loops: [],
            coaches: [],
            sessionsPerUser: 0,
            overallQuota: 0,
            expiryDate: '',
            performance: {
              checkinPassingRate: (subData.userPerformance || subData.performance) && (subData.userPerformance || subData.performance).checkinPassingRate !== undefined && (subData.userPerformance || subData.performance).checkinPassingRate !== null ? Math.round((subData.userPerformance || subData.performance).checkinPassingRate * 100) : 80,
              minimumStepCount: (subData.userPerformance || subData.performance) && (subData.userPerformance || subData.performance).minimumStepCount !== undefined && (subData.userPerformance || subData.performance).minimumStepCount !== null ? (subData.userPerformance || subData.performance).minimumStepCount : 0
            }
          };
          if (subData.individualCoaching) {
            form.sessionsPerUser = subData.individualCoaching.maxSessionsPerUser !== undefined && subData.individualCoaching.maxSessionsPerUser !== null ? subData.individualCoaching.maxSessionsPerUser : 0;
            form.overallQuota = subData.individualCoaching.overallSessionQuota || 0;
            var bookingExpiry = subData.individualCoaching.bookingExpiry;
            if (typeof bookingExpiry === 'string') {
              form.expiryDate = bookingExpiry.substring(0, 10);
            }
          }
          var orgPromise = (0, _organizations.getAllOrganizations)(token).then(function (orgResponse) {
            if (orgResponse.data && orgResponse.data.rows) {
              var org = orgResponse.data.rows.find(function (o) {
                return o.id === subData.organizationId;
              });
              if (org) {
                form.organization = org.name;
              }
            }
          }).catch(function (err) {
            (0, _log.showDebugLog)('org-lookup-error', err);
          });
          var loopPromise = _this2.fetchSubscriptionLoops(token, subData.relatedPrograms).then(function (loops) {
            form.loops = loops;
          });
          var coachPromises = [];
          if (subData.coaches) {
            var validCoaches = subData.coaches.filter(function (coach) {
              return coach.userUuid;
            });
            form.coaches = new Array(validCoaches.length);
            validCoaches.forEach(function (coach, index) {
              var p = (0, _user.getUser)(token, coach.userUuid).then(function (userRes) {
                var userData = userRes.data;
                form.coaches[index] = {
                  uuid: coach.userUuid,
                  givenName: userData.givenName || '',
                  familyName: userData.familyName || '',
                  email: userData.email || '',
                  calendlyLink: coach.calendlyEventTypeLinkWithSlug || coach.calendlyEventTypeLink || '',
                  calendlyEventTypeLink: coach.calendlyEventTypeLink || '',
                  enabled: typeof coach.isEnabled === 'boolean' ? coach.isEnabled : true
                };
              }).catch(function (err) {
                (0, _log.showDebugLog)('coach-user-error', err);
                form.coaches[index] = {
                  uuid: coach.userUuid,
                  givenName: 'Coach',
                  familyName: coach.userUuid.substring(0, 8),
                  email: '',
                  calendlyLink: coach.calendlyEventTypeLinkWithSlug || coach.calendlyEventTypeLink || '',
                  calendlyEventTypeLink: coach.calendlyEventTypeLink || '',
                  enabled: typeof coach.isEnabled === 'boolean' ? coach.isEnabled : true
                };
              });
              coachPromises.push(p);
            });
          }
          return Promise.all([orgPromise, loopPromise].concat(coachPromises)).then(function () {
            form.coaches = form.coaches.filter(Boolean);
            _this2.form = form;
            _this2.initialSessionsPerUser = form.sessionsPerUser;
            _this2.updateCount = subData.updateCount || 0;
            if (Number(form.overallQuota) > 0) {
              _this2.quotaType = 'limited';
              _this2.limitedQuotaValue = Number(form.overallQuota);
            } else {
              _this2.quotaType = 'unlimited';
              _this2.limitedQuotaValue = 1000;
            }
            _this2.savedForm = _lodash.default.cloneDeep(_this2.form);
            _this2.fullscreenloading = false;
            _this2.loadUserRecordsStatistics();
          });
        }).catch(function (error) {
          (0, _log.showDebugLog)('getSubscriptionById-error', error);
          _this2.fullscreenloading = false;
        });
      }
    },
    openLoopDialog: function openLoopDialog() {
      this.dialogLoopVisible = true;
      this.searchLoops();
    },
    searchLoops: function searchLoops() {
      var _this3 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loopTableLoading = true;
      var queryParams = {
        tenants: this.form.tenant,
        page: this.loopQuery.page,
        limit: this.loopQuery.limit
      };
      if (this.loopQuery.q) {
        queryParams.q = this.loopQuery.q;
      }
      if (token) {
        (0, _loop.getLoopList)(token, queryParams).then(function (response) {
          _this3.loopList = response.data.rows;
          _this3.loopTotal = response.data.count;
          _this3.loopTableLoading = false;
        }).catch(function (error) {
          (0, _log.showDebugLog)('getLoopList-error', error);
        });
      }
    },
    fetchSubscriptionLoops: function fetchSubscriptionLoops(token, relatedPrograms) {
      var _this4 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var loopPrograms, loops, loopPromises;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (Array.isArray(relatedPrograms)) {
                _context.n = 1;
                break;
              }
              return _context.a(2, []);
            case 1:
              loopPrograms = relatedPrograms.filter(function (program) {
                return program && program.programType === 'Loop' && program.programId;
              });
              loops = new Array(loopPrograms.length);
              loopPromises = loopPrograms.map(function (program, index) {
                return (0, _loop.getLoopById)(token, program.programId).then(function (loopRes) {
                  var loopData = loopRes.data;
                  return _this4.fetchLoopHikes(token, loopData).then(function (hikes) {
                    loops[index] = {
                      id: loopData.id,
                      title: loopData.title,
                      hikes: hikes
                    };
                  });
                }).catch(function (err) {
                  (0, _log.showDebugLog)('loop-details-error', err);
                  loops[index] = {
                    id: program.programId,
                    title: 'Loop: ' + program.programId,
                    hikes: []
                  };
                });
              });
              _context.n = 2;
              return Promise.all(loopPromises);
            case 2:
              return _context.a(2, loops.filter(Boolean));
          }
        }, _callee);
      }))();
    },
    fetchLoopHikes: function fetchLoopHikes(token, loopData) {
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var hikes, hikePromises;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              hikes = [];
              if (!(loopData && Array.isArray(loopData.programs))) {
                _context2.n = 1;
                break;
              }
              hikePromises = [];
              loopData.programs.forEach(function (program) {
                if (program && program.type === 'enrollment' && Array.isArray(program.options)) {
                  program.options.forEach(function (option) {
                    if (option && option.objectType === 'hike' && option.objectId) {
                      var hikeId = option.objectId;
                      var p = (0, _hike.getHikeById)(token, hikeId).then(function (hikeRes) {
                        var hikeData = hikeRes.data || {};
                        var hikeTitle = hikeData.title || option.objectData && option.objectData.title || option.title || 'Untitled Hike';
                        var mandatoryActivities = [];
                        if (Array.isArray(hikeData.stages)) {
                          hikeData.stages.forEach(function (stage, stageIndex) {
                            var stageTitle = stage.title || 'Stage ' + (stageIndex + 1);
                            if (Array.isArray(stage.actionSets)) {
                              stage.actionSets.forEach(function (actionSet, actionSetIndex) {
                                var actionSetTitle = actionSet.type || actionSet.title || 'Activity ' + (actionSetIndex + 1);
                                if (Array.isArray(actionSet.actions)) {
                                  actionSet.actions.forEach(function (action, actionIndex) {
                                    if (action && (action.isSubscriptionIndividualCoachingMandatoryActivity === true || action.isSubscriptionIndividualCoachingMandatoryActivity === 'true')) {
                                      var actionTitle = action.title || 'Component ' + (actionIndex + 1);
                                      mandatoryActivities.push({
                                        hikeId: hikeId,
                                        hikeTitle: hikeTitle,
                                        stageTitle: stageTitle,
                                        activityTitle: actionSetTitle,
                                        componentTitle: actionTitle,
                                        actionId: action.id || action._id,
                                        key: "".concat(hikeId, "_").concat(stage.id || stageIndex, "_").concat(actionSet.id || actionSetIndex, "_").concat(action.id || actionIndex),
                                        displayText: "".concat(hikeTitle, " > ").concat(stageTitle, " > ").concat(actionSetTitle, " > ").concat(actionTitle)
                                      });
                                    }
                                  });
                                }
                              });
                            }
                          });
                        }
                        hikes.push({
                          id: hikeId,
                          title: hikeTitle,
                          mandatoryActivities: mandatoryActivities
                        });
                      }).catch(function (err) {
                        (0, _log.showDebugLog)('getHikeById-error', err);
                        hikes.push({
                          id: hikeId,
                          title: option.objectData && option.objectData.title || option.title || 'Untitled Hike',
                          mandatoryActivities: []
                        });
                      });
                      hikePromises.push(p);
                    }
                  });
                }
              });
              _context2.n = 1;
              return Promise.all(hikePromises);
            case 1:
              return _context2.a(2, hikes);
          }
        }, _callee2);
      }))();
    },
    addLoop: function addLoop(row) {
      var _this5 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      if (this.form.loops.some(function (loop) {
        return loop.id === row.id;
      })) {
        (0, _log.displayPopupMessage)('This loop has already been added.', 'warning');
        this.dialogLoopVisible = false;
        return;
      }
      this.fullscreenloading = true;
      if (token) {
        (0, _loop.getLoopById)(token, row.id).then(function (response) {
          var loopData = response.data;
          return _this5.fetchLoopHikes(token, loopData).then(function (hikes) {
            _this5.form.loops.push({
              id: loopData.id,
              title: loopData.title,
              hikes: hikes
            });
            _this5.fullscreenloading = false;
            _this5.dialogLoopVisible = false;
          });
        }).catch(function (error) {
          (0, _log.showDebugLog)('getLoopById-error', error);
          _this5.fullscreenloading = false;
        });
      } else {
        this.fullscreenloading = false;
      }
    },
    removeLoop: function removeLoop(index) {
      this.form.loops.splice(index, 1);
    },
    handleLoopSizeChange: function handleLoopSizeChange(val) {
      this.loopQuery.limit = val;
      this.searchLoops();
    },
    handleLoopCurrentChange: function handleLoopCurrentChange(val) {
      this.loopQuery.page = val;
      this.searchLoops();
    },
    openCoachDialog: function openCoachDialog() {
      this.dialogCoachVisible = true;
      this.searchCoaches();
    },
    searchCoaches: function searchCoaches() {
      var _this6 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.coachTableLoading = true;
      var queryParams = {
        page: this.coachQuery.page,
        limit: this.coachQuery.limit,
        role: Constants.USER_ROLE_OTR_COACH
      };
      if (this.coachQuery.q) {
        queryParams.q = this.coachQuery.q;
      }
      if (token) {
        (0, _user.getUserList)(token, queryParams).then(function (response) {
          _this6.coachList = response.data.rows;
          _this6.coachTotal = response.data.count;
          _this6.coachTableLoading = false;
        }).catch(function (error) {
          (0, _log.showDebugLog)('getUserList-error', error);
        });
      }
    },
    addCoach: function addCoach(row) {
      if (this.form.coaches.some(function (c) {
        return c.uuid === row.uuid;
      })) {
        (0, _log.displayPopupMessage)('This coach has already been added.', 'warning');
        this.dialogCoachVisible = false;
        return;
      }
      this.form.coaches.push({
        uuid: row.uuid,
        givenName: row.givenName,
        familyName: row.familyName,
        email: row.email,
        calendlyLink: '',
        calendlyEventTypeLink: '',
        enabled: true
      });
      this.dialogCoachVisible = false;
      (0, _log.displayPopupMessage)('Coach added successfully.', 'success');
    },
    removeCoach: function removeCoach(index) {
      var _this7 = this;
      this.$confirm('Are you sure you want to remove this coach?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(function () {
        _this7.form.coaches.splice(index, 1);
        (0, _log.displayPopupMessage)('Coach removed.', 'success');
      }).catch(function () {});
    },
    moveCoachUp: function moveCoachUp(index) {
      if (index > 0) {
        var temp = this.form.coaches[index];
        this.$set(this.form.coaches, index, this.form.coaches[index - 1]);
        this.$set(this.form.coaches, index - 1, temp);
      }
    },
    moveCoachDown: function moveCoachDown(index) {
      if (index < this.form.coaches.length - 1) {
        var temp = this.form.coaches[index];
        this.$set(this.form.coaches, index, this.form.coaches[index + 1]);
        this.$set(this.form.coaches, index + 1, temp);
      }
    },
    handleCoachSizeChange: function handleCoachSizeChange(val) {
      this.coachQuery.limit = val;
      this.searchCoaches();
    },
    handleCoachCurrentChange: function handleCoachCurrentChange(val) {
      this.coachQuery.page = val;
      this.searchCoaches();
    },
    doSave: function doSave() {
      var _this8 = this;
      if (!this.form.title) {
        (0, _log.displayPopupMessage)('Subscription Title is required.', 'error');
        return;
      }
      if (!this.form.startDate) {
        (0, _log.displayPopupMessage)('Start date is required.', 'error');
        return;
      }
      if (!this.form.endDate) {
        (0, _log.displayPopupMessage)('End date is required.', 'error');
        return;
      }
      if (new Date(this.form.endDate) < new Date(this.form.startDate)) {
        (0, _log.displayPopupMessage)('End date cannot be earlier than start date.', 'error');
        return;
      }
      if (this.updateCount > 0 && this.form.sessionsPerUser < this.initialSessionsPerUser) {
        (0, _log.displayPopupMessage)("Number of sessions per user cannot be less than the previous setting of ".concat(this.initialSessionsPerUser, " as it will affect the current bookings."), 'error');
        return;
      }
      if (Number(this.form.overallQuota) !== 0 && Number(this.form.overallQuota) < Number(this.form.sessionsPerUser)) {
        (0, _log.displayPopupMessage)('Total session quota must be 0 or equal or greater than Number of sessions per user.', 'error');
        return;
      }

      // Check that all coaches have a Calendly link
      var _iterator = (0, _createForOfIteratorHelper2.default)(this.form.coaches),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var coach = _step.value;
          if (!coach.calendlyLink || !coach.calendlyLink.trim()) {
            (0, _log.displayPopupMessage)("Calendly Event Type Link is required for coach ".concat(coach.givenName, " ").concat(coach.familyName, "."), 'error');
            return;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      if (token && this.form.id) {
        var org = this.organizations.find(function (o) {
          return o.name === _this8.form.organization;
        });
        var organizationId = org ? org.id : this.form.organization;
        var payload = {
          metadata: {
            tenant: this.form.tenant
          },
          organizationId: organizationId,
          title: this.form.title,
          startDate: this.form.startDate ? new Date(this.form.startDate + 'T00:00:00.000Z').toISOString() : null,
          endDate: this.form.endDate ? new Date(this.form.endDate + 'T23:59:59.000Z').toISOString() : null,
          relatedPrograms: this.form.loops.map(function (loop) {
            return {
              programType: 'Loop',
              programId: loop.id
            };
          }),
          userPerformance: {
            checkinPassingRate: this.form.performance && this.form.performance.checkinPassingRate !== null && this.form.performance.checkinPassingRate !== undefined ? Number((Number(this.form.performance.checkinPassingRate) / 100).toFixed(4)) : 0.8,
            minimumStepCount: this.form.performance && this.form.performance.minimumStepCount !== null && this.form.performance.minimumStepCount !== undefined ? Number(this.form.performance.minimumStepCount) : 0
          },
          individualCoaching: {
            maxSessionsPerUser: this.form.sessionsPerUser,
            overallSessionQuota: this.form.overallQuota,
            bookingExpiry: this.form.expiryDate || null
          },
          coaches: this.form.coaches.map(function (coach) {
            return {
              userUuid: coach.uuid,
              calendlyEventTypeLinkWithSlug: coach.calendlyLink,
              calendlyEventTypeLink: coach.calendlyEventTypeLink || '',
              isEnabled: coach.enabled
            };
          }),
          status: this.form.status ? this.form.status.toLowerCase() : 'published'
        };
        if (this.updateCount === 0) {
          this.$confirm("Please confirm that \"Number of sessions per user\" is set correctly. It cannot be changed after this update.", 'Warning', {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }).then(function () {
            _this8.executeSave(token, payload);
          }).catch(function () {});
        } else {
          this.executeSave(token, payload);
        }
      }
    },
    executeSave: function executeSave(token, payload) {
      var _this9 = this;
      this.fullscreenloading = true;
      (0, _subscriptions.updateSubscription)(token, this.form.id, payload).then(function (response) {
        _this9.fullscreenloading = false;
        (0, _log.displayPopupMessage)('Subscription updated successfully.', 'success');
        _this9.updateCount += 1;
        _this9.initialSessionsPerUser = _this9.form.sessionsPerUser;
        _this9.savedForm = _lodash.default.cloneDeep(_this9.form);
      }).catch(function (error) {
        (0, _log.showDebugLog)('updateSubscription-api-error', error);
        _this9.fullscreenloading = false;
        (0, _log.displayPopupMessage)('Failed to update subscription. ' + (error.message || ''), 'error');
      });
    },
    hasUnsavedChanges: function hasUnsavedChanges() {
      if (!this.savedForm) {
        return false;
      }
      return !_lodash.default.isEqual(this.form, this.savedForm);
    },
    refreshSubscriptionLoopsAndHikes: function refreshSubscriptionLoopsAndHikes() {
      var _this0 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var subId, token, response, subData, loops, _t;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              subId = _this0.$route.params.id || _this0.form.id;
              token = (0, _cookie.getCookie)('ACCESS_TOKEN');
              if (!(!token || !subId)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              _context3.p = 1;
              _context3.n = 2;
              return (0, _subscriptions.getSubscriptionById)(token, subId);
            case 2:
              response = _context3.v;
              subData = response.data;
              if (!(subData && subData.relatedPrograms)) {
                _context3.n = 4;
                break;
              }
              _context3.n = 3;
              return _this0.fetchSubscriptionLoops(token, subData.relatedPrograms);
            case 3:
              loops = _context3.v;
              _this0.form.loops = loops;
              if (_this0.savedForm) {
                _this0.savedForm.loops = _lodash.default.cloneDeep(loops);
              }
            case 4:
              _context3.n = 6;
              break;
            case 5:
              _context3.p = 5;
              _t = _context3.v;
              (0, _log.showDebugLog)('refreshSubscriptionLoopsAndHikes-error', _t);
            case 6:
              return _context3.a(2);
          }
        }, _callee3, null, [[1, 5]]);
      }))();
    },
    goBack: function goBack() {
      var _this1 = this;
      this.$store.dispatch('tagsView/delView', this.$route).then(function () {
        _this1.$router.push({
          path: '/subscriptions/index'
        });
      });
    },
    loadUserRecords: function loadUserRecords() {
      var _this10 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var subId = this.$route.params.id || this.form.id;
      if (token && subId) {
        this.userRecordsLoading = true;
        var params = {
          page: this.userRecordsQuery.page,
          limit: this.userRecordsQuery.limit
        };
        if (this.userRecordsQuery.search && this.userRecordsQuery.search.trim()) {
          params.q = this.userRecordsQuery.search.trim();
        }
        (0, _subscriptions.getSubscriptionUserRecords)(token, subId, params).then(function (response) {
          if (response.data && response.data.rows) {
            _this10.userRecordsList = response.data.rows;
            _this10.userRecordsTotal = response.data.count || 0;
          } else {
            _this10.userRecordsList = [];
            _this10.userRecordsTotal = 0;
          }
          _this10.userRecordsLoading = false;
        }).catch(function (error) {
          (0, _log.showDebugLog)('getSubscriptionUserRecords-error', error);
          _this10.userRecordsLoading = false;
        });
        this.loadUserRecordsStatistics();
      }
    },
    handleRefreshUserRecords: function handleRefreshUserRecords() {
      var _this11 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!_this11.hasUnsavedChanges()) {
                _context4.n = 1;
                break;
              }
              _this11.$alert('There are unsaved changes in the Subscription. Please save your changes before refreshing.', 'Warning', {
                confirmButtonText: 'OK',
                type: 'warning'
              }).catch(function () {});
              return _context4.a(2);
            case 1:
              _this11.userRecordsLoading = true;
              _context4.n = 2;
              return _this11.refreshSubscriptionLoopsAndHikes();
            case 2:
              _this11.loadUserRecords();
            case 3:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    handleUserRecordsSearch: function handleUserRecordsSearch() {
      var _this12 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5() {
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (!_this12.hasUnsavedChanges()) {
                _context5.n = 1;
                break;
              }
              _this12.$alert('There are unsaved changes in the Subscription. Please save your changes before refreshing.', 'Warning', {
                confirmButtonText: 'OK',
                type: 'warning'
              }).catch(function () {});
              return _context5.a(2);
            case 1:
              _this12.userRecordsQuery.page = 1;
              _this12.userRecordsLoading = true;
              _context5.n = 2;
              return _this12.refreshSubscriptionLoopsAndHikes();
            case 2:
              _this12.loadUserRecords();
            case 3:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    handleUserRecordsSizeChange: function handleUserRecordsSizeChange(val) {
      this.userRecordsQuery.limit = val;
      this.userRecordsQuery.page = 1;
      this.loadUserRecords();
    },
    handleUserRecordsCurrentChange: function handleUserRecordsCurrentChange(val) {
      this.userRecordsQuery.page = val;
      this.loadUserRecords();
    },
    viewUserChangelog: function viewUserChangelog(row) {
      this.selectedUserName = row.user && row.user.givenName + ' ' + row.user.familyName || 'User';
      this.selectedUserChangelog = row.subscriptionRecord && row.subscriptionRecord.changelog || [];
      this.dialogChangelogVisible = true;
    },
    formatLogDate: function formatLogDate(dateStr) {
      if (!dateStr) return '';
      var date = new Date(dateStr);
      var pad = function pad(num) {
        return String(num).padStart(2, '0');
      };
      var YYYY = date.getUTCFullYear();
      var MM = pad(date.getUTCMonth() + 1);
      var DD = pad(date.getUTCDate());
      var hh = pad(date.getUTCHours());
      var mm = pad(date.getUTCMinutes());
      var ss = pad(date.getUTCSeconds());
      return "".concat(YYYY, "-").concat(MM, "-").concat(DD, " ").concat(hh, ":").concat(mm, ":").concat(ss, " UTC");
    },
    formatBeforeState: function formatBeforeState(stateStr) {
      try {
        var parsed = JSON.parse(stateStr);
        return JSON.stringify(parsed, null, 2);
      } catch (e) {
        return stateStr;
      }
    },
    formatTargetCompletionRate: function formatTargetCompletionRate(val) {
      if (val === undefined || val === null) return '';
      if (val > 0 && val <= 1) {
        return Math.round(val * 100) + '%';
      }
      return val + '%';
    },
    getStepCount: function getStepCount(row) {
      var rec = row.subscriptionRecord || row;
      var perf = rec.userPerformance || rec.performance;
      if (perf && perf.stepCount !== undefined && perf.stepCount !== null) {
        return perf.stepCount;
      }
      if (rec.stepCount !== undefined && rec.stepCount !== null) {
        return rec.stepCount;
      }
      if (row.stepCount !== undefined && row.stepCount !== null) {
        return row.stepCount;
      }
      if (perf && perf.stepTotal !== undefined && perf.stepTotal !== null) {
        return perf.stepTotal;
      }
      if (rec.stepTotal !== undefined && rec.stepTotal !== null) {
        return rec.stepTotal;
      }
      if (row.stepTotal !== undefined && row.stepTotal !== null) {
        return row.stepTotal;
      }
      if (rec.steps !== undefined && rec.steps !== null) {
        return rec.steps;
      }
      return 0;
    },
    getMaxStepCount: function getMaxStepCount(row) {
      var rec = row.subscriptionRecord || row;
      var perf = rec.userPerformance || rec.performance;
      if (perf && perf.maxStepCount !== undefined && perf.maxStepCount !== null) {
        return perf.maxStepCount;
      }
      if (rec.maxStepCount !== undefined && rec.maxStepCount !== null) {
        return rec.maxStepCount;
      }
      if (row.maxStepCount !== undefined && row.maxStepCount !== null) {
        return row.maxStepCount;
      }
      if (perf && perf.maxStepTotal !== undefined && perf.maxStepTotal !== null) {
        return perf.maxStepTotal;
      }
      if (rec.maxStepTotal !== undefined && rec.maxStepTotal !== null) {
        return rec.maxStepTotal;
      }
      if (row.maxStepTotal !== undefined && row.maxStepTotal !== null) {
        return row.maxStepTotal;
      }
      return this.totalStepCount !== undefined && this.totalStepCount !== null ? this.totalStepCount : 0;
    },
    getStepTotal: function getStepTotal(row) {
      return this.getStepCount(row);
    },
    getMaxStepTotal: function getMaxStepTotal(row) {
      return this.getMaxStepCount(row);
    },
    isStepCountPassing: function isStepCountPassing(row) {
      var stepCount = this.getStepCount(row);
      var minStepCount = this.form.performance && this.form.performance.minimumStepCount !== undefined && this.form.performance.minimumStepCount !== null ? Number(this.form.performance.minimumStepCount) : 0;
      return stepCount >= minStepCount;
    },
    getCheckinCount: function getCheckinCount(row) {
      var rec = row.subscriptionRecord || row;
      var perf = rec.userPerformance || rec.performance;
      if (perf && perf.checkinCount !== undefined && perf.checkinCount !== null) {
        return perf.checkinCount;
      }
      if (rec.checkinCount !== undefined && rec.checkinCount !== null) {
        return rec.checkinCount;
      }
      if (row.checkinCount !== undefined && row.checkinCount !== null) {
        return row.checkinCount;
      }
      if (perf && perf.checkinTotal !== undefined && perf.checkinTotal !== null) {
        return perf.checkinTotal;
      }
      if (rec.checkinTotal !== undefined && rec.checkinTotal !== null) {
        return rec.checkinTotal;
      }
      if (row.checkinTotal !== undefined && row.checkinTotal !== null) {
        return row.checkinTotal;
      }
      return 0;
    },
    getMaxCheckinCount: function getMaxCheckinCount(row) {
      var rec = row.subscriptionRecord || row;
      var perf = rec.userPerformance || rec.performance;
      if (perf && perf.maxCheckinCount !== undefined && perf.maxCheckinCount !== null) {
        return perf.maxCheckinCount;
      }
      if (rec.maxCheckinCount !== undefined && rec.maxCheckinCount !== null) {
        return rec.maxCheckinCount;
      }
      if (row.maxCheckinCount !== undefined && row.maxCheckinCount !== null) {
        return row.maxCheckinCount;
      }
      if (perf && perf.maxCheckinTotal !== undefined && perf.maxCheckinTotal !== null) {
        return perf.maxCheckinTotal;
      }
      if (rec.maxCheckinTotal !== undefined && rec.maxCheckinTotal !== null) {
        return rec.maxCheckinTotal;
      }
      if (row.maxCheckinTotal !== undefined && row.maxCheckinTotal !== null) {
        return row.maxCheckinTotal;
      }
      return this.totalCheckinStageCount !== undefined && this.totalCheckinStageCount !== null ? this.totalCheckinStageCount : 0;
    },
    isCheckinCountPassing: function isCheckinCountPassing(row) {
      var checkinCount = this.getCheckinCount(row);
      var maxCheckin = this.getMaxCheckinCount(row);
      var passingRatePercent = this.form.performance && this.form.performance.checkinPassingRate !== undefined && this.form.performance.checkinPassingRate !== null ? Number(this.form.performance.checkinPassingRate) : 80;
      var checkinPassingRateFloat = passingRatePercent / 100;
      var requiredCheckins = maxCheckin * checkinPassingRateFloat;
      return checkinCount >= requiredCheckins;
    },
    getCheckinPercentage: function getCheckinPercentage(row) {
      var rec = row.subscriptionRecord || row;
      var perf = rec.userPerformance || rec.performance;
      if (perf && perf.checkinPercentage !== undefined && perf.checkinPercentage !== null) {
        return Math.round(Number(perf.checkinPercentage));
      }
      if (rec.checkinPercentage !== undefined && rec.checkinPercentage !== null) {
        return Math.round(Number(rec.checkinPercentage));
      }
      if (row.checkinPercentage !== undefined && row.checkinPercentage !== null) {
        return Math.round(Number(row.checkinPercentage));
      }
      var maxCount = this.getMaxCheckinCount(row);
      if (!maxCount || maxCount === 0) return 0;
      var count = this.getCheckinCount(row);
      return Math.round(count / maxCount * 100);
    },
    getCompletedMandatoryHikeActivityCount: function getCompletedMandatoryHikeActivityCount(row) {
      return _lodash.default.get(row, 'subscriptionRecord.performance.completedMandatoryHikeActivityCount', 0);
    },
    getMandatoryHikeActivityCount: function getMandatoryHikeActivityCount(row) {
      return _lodash.default.get(row, 'subscriptionRecord.performance.mandatoryHikeActivityCount', 0);
    },
    isMandatoryHikeActivityPassing: function isMandatoryHikeActivityPassing(row) {
      var completed = this.getCompletedMandatoryHikeActivityCount(row);
      var total = this.getMandatoryHikeActivityCount(row);
      return completed >= total;
    },
    viewMandatoryActivities: function viewMandatoryActivities(row) {
      this.selectedUserName = row.user && row.user.givenName + ' ' + row.user.familyName || 'User';
      this.selectedUserMandatoryActivities = this.getMandatoryActivitiesDetails(row);
      this.dialogMandatoryActivitiesVisible = true;
    },
    getMandatoryActivitiesDetails: function getMandatoryActivitiesDetails(row) {
      if (!this.mandatoryHikeActivities || this.mandatoryHikeActivities.length === 0) {
        return [];
      }
      var completedActivities = _lodash.default.get(row, 'subscriptionRecord.performance.mandatoryHikeActivities', []);
      return this.mandatoryHikeActivities.map(function (act) {
        var isCompleted = completedActivities.some(function (c) {
          return String(c.hikeId) === String(act.hikeId) && String(c.actionId) === String(act.actionId);
        });
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, act), {}, {
          isCompleted: isCompleted
        });
      });
    },
    getPassingCompletionRate: function getPassingCompletionRate(row) {
      var rec = row.subscriptionRecord || row;
      var perf = rec.userPerformance || rec.performance;
      var val = null;
      if (perf && perf.passingCompletionRate !== undefined && perf.passingCompletionRate !== null) {
        val = perf.passingCompletionRate;
      } else if (rec.passingCompletionRate !== undefined && rec.passingCompletionRate !== null) {
        val = rec.passingCompletionRate;
      } else if (row.passingCompletionRate !== undefined && row.passingCompletionRate !== null) {
        val = row.passingCompletionRate;
      } else if (perf && perf.completionRate !== undefined && perf.completionRate !== null) {
        val = perf.completionRate;
      } else if (rec.completionRate !== undefined && rec.completionRate !== null) {
        val = rec.completionRate;
      } else {
        val = 0;
      }
      if (typeof val === 'string') {
        val = parseFloat(val.replace('%', ''));
        if (isNaN(val)) val = 0;
      }
      return val;
    },
    getPassingCompletionRateValue: function getPassingCompletionRateValue(row) {
      var val = this.getPassingCompletionRate(row);
      if (val > 1) {
        return Math.min(100, Math.max(0, Math.round(val)));
      }
      return Math.min(100, Math.max(0, Math.round(val * 100)));
    },
    getCompletionRate: function getCompletionRate(row) {
      var rec = row.subscriptionRecord || row;
      var perf = rec.userPerformance || rec.performance;
      if (perf && perf.completionRate !== undefined) {
        return perf.completionRate;
      }
      if (rec.completionRate !== undefined) {
        return rec.completionRate;
      }
      return 0;
    },
    viewCoachingBookings: function viewCoachingBookings(row) {
      var _this13 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var subId = this.$route.params.id || this.form.id;
      var userUuid = row.user.uuid || row.subscriptionRecord && row.subscriptionRecord.userUuid || row.userUuid;
      this.selectedUserName = row.user && row.user.givenName + ' ' + row.user.familyName || 'User';
      this.bookingsList = [];
      this.bookingsLoading = true;
      this.dialogBookingsVisible = true;
      if (token && subId && userUuid) {
        (0, _subscriptions.getIndividualCoachingBookings)(token, subId, userUuid).then(function (response) {
          var bookings = response.data && response.data.rows || [];
          _this13.bookingsList = bookings;

          // Find all unique coach UUIDs we don't have in coachMap
          var uniqueCoaches = Array.from(new Set(bookings.map(function (b) {
            return b.coachUuid;
          }).filter(function (uuid) {
            return uuid && !_this13.coachMap[uuid];
          })));

          // Query names for these coach UUIDs
          var coachPromises = uniqueCoaches.map(function (uuid) {
            return (0, _user.getUser)(token, uuid).then(function (userRes) {
              var name = (userRes.data.givenName || '') + ' ' + (userRes.data.familyName || '');
              _this13.$set(_this13.coachMap, uuid, name.trim() || 'Coach');
            }).catch(function (err) {
              (0, _log.showDebugLog)('getUser-coach-error', err);
              _this13.$set(_this13.coachMap, uuid, 'Coach (' + uuid.substring(0, 8) + ')');
            });
          });
          return Promise.all(coachPromises);
        }).then(function () {
          _this13.bookingsLoading = false;
        }).catch(function (error) {
          (0, _log.showDebugLog)('getIndividualCoachingBookings-error', error);
          _this13.bookingsLoading = false;
          (0, _log.displayPopupMessage)('Failed to load coaching bookings.', 'error');
        });
      } else {
        this.bookingsLoading = false;
        (0, _log.displayPopupMessage)('Missing booking identifier.', 'error');
      }
    },
    formatBookingTime: function formatBookingTime(utcStr) {
      if (!utcStr) return '';
      var date = new Date(utcStr);
      var pad = function pad(num) {
        return String(num).padStart(2, '0');
      };
      var YYYY = date.getFullYear();
      var MM = pad(date.getMonth() + 1);
      var DD = pad(date.getDate());
      var hh = pad(date.getHours());
      var mm = pad(date.getMinutes());
      var ss = pad(date.getSeconds());
      return "".concat(YYYY, "-").concat(MM, "-").concat(DD, " ").concat(hh, ":").concat(mm, ":").concat(ss);
    },
    getBookingStatusType: function getBookingStatusType(status) {
      switch (status) {
        case 'booked':
          return 'success';
        case 'open':
          return 'info';
        case 'cancelled':
          return 'danger';
        default:
          return 'warning';
      }
    },
    handleTabClick: function handleTabClick(tab) {
      var hash = tab.name === 'user-records' ? '#user-records' : '';
      if (this.$route.hash !== hash) {
        var p = this.$router.replace({
          hash: hash
        });
        if (p && typeof p.catch === 'function') {
          p.catch(function () {});
        }
      }
    },
    loadUserRecordsStatistics: function loadUserRecordsStatistics() {
      var _this14 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var subId = this.$route.params.id || this.form.id;
      if (token && subId) {
        (0, _subscriptions.getSubscriptionStatistics)(token, subId).then(function (response) {
          if (response && response.data) {
            _this14.userRecordsStats = response.data.relatedHikesInfo || response.data.individualCoaching ? response.data : response.data.data || response.data;
          }
        }).catch(function (error) {
          (0, _log.showDebugLog)('getSubscriptionStatistics-error', error);
        });
      }
    }
  }
};